import { default as CaseStudies } from "./case-studies-root";

export default CaseStudies;
